'use client';
import { useQuery } from '@tanstack/react-query';
import { getThemedCoverages } from '@pulsex/services';
export default function useThemedCoverages(config) {
    const query = useQuery({
        queryKey: ['GET_THEMED_COVERAGES'],
        queryFn: () => getThemedCoverages(config),
        refetchOnWindowFocus: false,
    });
    if (query.isError) {
        console.error('Query Error:', query.error);
    }
    return {
        isLoading: query.isLoading,
        data: query.data,
    };
}
